import { ArrowUpRight, LogIn } from 'lucide-react'
import { Link } from 'react-router'

import { link, ownerPaths, paths } from '@/app/router/paths.ts'
import type { Business } from '@/features/business/model/business.ts'
import { shortName } from '@/lib/format/studioName.ts'

/** The reference's footer: the studio's name and the way to reach it. */
export function AppFooter({ business, isOwner = false }: { readonly business: Business; readonly isOwner?: boolean }) {
  return (
    <footer className="mx-auto w-full max-w-5xl px-4 pb-4 sm:px-6">
      <div className="flex items-center justify-between gap-4 border-t border-border pt-6">
        <span className="text-base text-muted-foreground">{shortName(business.name)}</span>
        <Link
          to={link(paths.contacts)}
          className="inline-flex min-h-12 cursor-pointer items-center gap-2 rounded-md text-base text-muted-foreground transition-colors hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none"
        >
          Связаться
          <ArrowUpRight className="size-5" aria-hidden="true" />
        </Link>
      </div>
      <Link
        to={link(ownerPaths.root)}
        className="mt-3 ml-auto flex min-h-12 w-fit cursor-pointer items-center justify-center gap-2 rounded-full border border-border px-4 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none"
      >
        <LogIn className="size-4" aria-hidden="true" />
        {isOwner ? 'Открыть кабинет' : 'Вход для владельца'}
      </Link>
    </footer>
  )
}
